import { useI18n } from './context';
import { LOCALE_NAMES, LOCALES, type Locale } from './locale';

/**
 * How the optional languages are chosen (ADR-031): a labelled select at the bottom of every
 * screen, on every platform. The options are the autonyms, never translated; the label is the
 * select's accessible name ("Language" / "Språk").
 */
export function LanguagePicker() {
  const { locale, messages, setLocale } = useI18n();
  return (
    <label>
      {messages.language.label}{' '}
      <select value={locale} onChange={(e) => setLocale(e.target.value as Locale)}>
        {LOCALES.map((option) => (
          <option key={option} value={option}>
            {LOCALE_NAMES[option]}
          </option>
        ))}
      </select>
    </label>
  );
}
